import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import Footer from '../Partials/SaleFooter/SaleFooter';
import {goToPage, reportDWH, setDisplayAlternativePackage} from '../energySaleBlockSlice';
import {getOderPrice, openWhatsAppLink} from '../energySaleBlockAsyncThunk';
import NoSmartMeterIcon from '../images/no-smart-meter.svg';
import YesSmartMeterIcon from '../images/yes-smart-meter.svg';
import CallIcon from '../images/call-icon.svg'

const ServiceMessagePage = (props) => {

  //page params
  let title = '';
  let subTitle = '';
  let iconType = '';
  let btnText = '';
  let btnFunction = null;
  let linkText = '';
  let isDisplayWhatsApp = false;
  let currentPageFunction = handlePageContinue;
  let isDisplayFooter = true;
  const formid = 'energySaleBlock';
  //page params

  switch (props.serviceMessageType) {
    case "SMART_METER":
      gtag4({
        event: props.isStartWithSelectedPackage ? 'Energy_Step5_CounterExistPage' : 'Energy_Step4_CounterExistPage',
        step: props.isStartWithSelectedPackage ? '5' :'4',
        action: 'CounterExistPage',
        funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
      });
      props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'Yes Counter- Display' })
      iconType = YesSmartMeterIcon;
      title = props.epiText.titleYesSmartMone;
      btnText = props.isStartWithSelectedPackage ? "לעדכון פרטים אישיים" : "כאן מתחיל החיסכון";
      btnFunction = goToNextPage;
      break;
    case "NOT_SMART_METER":
      gtag4({
        event: props.isStartWithSelectedPackage ? 'Energy_Step5_CounterNotExistPage' : 'Energy_Step4_CounterNotExistPage',
        step: props.isStartWithSelectedPackage ? '5' :'4',
        action: 'CounterNotExistPage',
        funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
      });
      props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'No Counter- Display' })
      iconType = NoSmartMeterIcon;
      title = props.epiText.titleNoSmartMone;
      btnText = props.isStartWithSelectedPackage ? "לעדכון פרטים אישיים" : "כאן מתחיל החיסכון";
      btnFunction = goToNextPage;
      break;
    case "WITHOUT_DETAILS":
      gtag4({
        event: props.isStartWithSelectedPackage ? 'Energy_Step5_NotReceivedInfoPage' : 'Energy_Step4_NotReceivedInfoPage',
        step: props.isStartWithSelectedPackage ? '5' :'4',
        action: 'NotReceivedInfoPage',
        funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
      });
      props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'No Info About Counter- display' })
      iconType = CallIcon;
      title = "כדי להשלים את התהליך \n נהיה איתך בקשר בדקות הקרובות";
      subTitle = "";
      isDisplayFooter = false;
      if(props.isWhatsAppActive){
        isDisplayWhatsApp = true;
        isDisplayFooter = true;
        btnText = 'לנציג שירות ב-WhatsApp';
        btnFunction = openWhatsAppLink;
      }
      break;
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={iconType} alt='' />
      <h1 className='energy-sale-title'  dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title'> {subTitle} </h2>
    </div>
  );

  return (
    <>
    <div className='energy-sale-content-wrapper'>
      {currentPageHeadline}
    </div>
    <Footer isDisplayFooter={isDisplayFooter} isDisplayWhatsAppIcon={isDisplayWhatsApp} btnText={btnText} onclick={currentPageFunction} formid={formid} />
    </>
  );

  function handlePageContinue() {
    btnFunction();
  }

  function goToNextPage(){
    switch (props.serviceMessageType) {
      case "SMART_METER":
      case "NOT_SMART_METER":
        gtag4({
          event: props.serviceMessageType == "SMART_METER" ? 'Energy_Step5_CounterExistButton' : 'Energy_Step4_CounterNotExistButton' ,
          step: props.isStartWithSelectedPackage ? '5' :'4',
          button: btnText,
          action: props.serviceMessageType == "SMART_METER" ? 'CounterExistButton' : 'CounterNotExistPage',
          funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
        });
        props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: props.serviceMessageType == "SMART_METER" ? 'Yes Counter- Clicked' : 'No Counter- Clicked' })
        if(props.isStartWithSelectedPackage){
          if(props.serviceMessageType == "SMART_METER" ){
            if(!props.selectedPackage.isSmartMeterPackage && !props.selectedPackage.isSuitableForAllMeterTypesPackage){
              props.setDisplayAlternativePackage(true);
              props.goToPage('packagesPage');
            }
            else if(props.selectedPackage.isSmartMeterPackage || props.selectedPackage.isSuitableForAllMeterTypesPackage){
              props.getOderPrice();
            }
          }
          else{
            if(props.selectedPackage.isSmartMeterPackage && !props.selectedPackage.isSuitableForAllMeterTypesPackage){
              props.setDisplayAlternativePackage(true);
              props.goToPage('packagesPage');
            }
            else if(props.selectedPackage.isSuitableForAllMeterTypesPackage){
              props.getOderPrice();
            }
          }
        }
        else{
          props.goToPage('packagesPage');
        }
        break;
    }
  }

  function openWhatsAppLink(){
    props.openWhatsAppLink();
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step5_NotReceivedInfoWaButton' : 'Energy_Step4_NotReceivedInfoWaButton' ,
      step: props.isStartWithSelectedPackage ? '5' :'4',
      button: linkText,
      action:  'NotReceivedInfoWaButton' ,
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'No Info About Counter- Clicked Whatsapp' })
  }


};

const mapStateToProps = (state) => {
  return {
    serviceMessageType: state.energySaleBlock.serviceMessageType,
    selectedPackage: state.energySaleBlock.selectedPackage,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
    isWhatsAppActive: state.energySaleBlock.energySaleBlockData.isWhatsAppActive,
    epiText: state.energySaleBlock.energySaleBlockData.epiText.serviceMessagePage
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  getOderPrice,
  openWhatsAppLink,
  reportDWH,
  setDisplayAlternativePackage
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceMessagePage);
